module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACISURBVHgBdY+xEcIwDEW/hAdw644R4k2yAiOkpExFyQhZwWVKNoAR3NGmJcgRMncU3MWvfad3+gTj2V+OTmWColPAEyEJyRDSmOkrN7lXgX+WwhLZLq87suIPxU2sih4tCB3XFNp4toceLWv1xPJyp0Zl2d4ycJjPuawu1mk/YXNvZZUY5jF/ACbhNeGI2cm/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/point_dot.png
// module id = mAVE
// module chunks = 1